<template>
  <div class="container-fluid" style="height: 100%; padding: 0px !important">
    <div style="background: #09819c; color: #fff; padding: 10px">
      <h6>
        Por favor, preencha o formulário abaixo para começar a conversar com o
        próximo agente disponível.
      </h6>
    </div>
    <div
      style="
        display: flex;
        flex-direction: column;
        height: 100vh;
        padding: 10px;
      "
    >
      <b-form
        @submit="onSubmit"
        @reset="onReset"
        v-if="show"
        style="
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 10px;
          heigth: 100%;
        "
      >
        <div style="flex: 1.5">
          <b-form-group id="input-group-1" label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              :state="validationEmail"
            ></b-form-input>
            <b-form-invalid-feedback :state="validationEmail"
              >Digite um email válido</b-form-invalid-feedback
            >
            <b-form-valid-feedback
              :state="validationEmail"
            ></b-form-valid-feedback>
          </b-form-group>

          <b-form-group id="input-group-2" label="Nome" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.nome"
              :state="validationName"
            ></b-form-input>
            <b-form-invalid-feedback :state="validationName"
              >Campo obrigatório</b-form-invalid-feedback
            >
            <b-form-valid-feedback
              :state="validationName"
            ></b-form-valid-feedback>
          </b-form-group>

          <b-form-group id="input-group-3" label="Telefone" label-for="input-3">
            <b-form-input
              id="input-3"
              v-model="form.numero"
              :state="validationTelefone"
            ></b-form-input>
            <b-form-invalid-feedback :state="validationTelefone"
              >Campo obrigatório</b-form-invalid-feedback
            >
            <b-form-valid-feedback
              :state="validationTelefone"
            ></b-form-valid-feedback>
          </b-form-group>

          <!-- <b-form-group
            id="input-group-4"
            label="Tipo de contato"
            label-for="input-4"
          >
            <b-form-select id="input-4" v-model="form.tipo" required>
              <option value="chat_reserva">Central de reservas</option>
              <option value="chat_elogios">Comercial/Parcerias</option>
              <option value="chat_infracoes">Infrações de Trânsito</option>
            </b-form-select>
          </b-form-group> -->
        </div>
        <div style="flex: 0.5">
          <b-button
            type="submit"
            size="lg"
            style="
              border-radius: 10px;
              width: 100%;
              background: #09819c;
              color: #fff;
            "
            >Iniciar Chat</b-button
          >
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("Atendimento");
import Swal from "sweetalert2";
export default {
  data() {
    return {
      form: {
        email: "",
        nome: "",
        tipo: "Atendimento_WebChat",
        numero: "",
      },
      show: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    validationEmail() {
      if (this.form.email.indexOf("@") !== -1) {
        return true;
      } else {
        return false;
      }
    },
    validationName() {
      if (this.form.nome.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    validationTelefone() {
      if (this.form.numero.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.verificaStorage();
  },
  methods: {
    ...mapActions(["login", "setState", "getState", "removeState"]),
    onSubmit(evt) {
      evt.preventDefault();
      this.login(this.form);
      this.$router.push("/chat");
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.numero = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    verificaStorage() {
      if (localStorage.getItem("state")) {
        // this.setState();
        Swal.fire({
          title: "Alerta!",
          text:
            "Verifiquei que você já possui uma sessão de chat aberta, gostaria de continuar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.value) {
            Swal.fire("Alerta", "Sua sessão foi restaurada", "success");
            this.getState();
            this.$router.push("/chat");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire("Alerta", "preencha os dados para prosseguir", "error");
            this.removeState();
            localStorage.removeItem("state");
          }
        });
      }
    },
  },
};
</script>